/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerNoteCreate } from '../models/CustomerNoteCreate';
import type { CustomerNotesDto } from '../models/CustomerNotesDto';
import type { CustomerProfile } from '../models/CustomerProfile';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomerService {

  /**
   * @param regno 
   * @param email 
   * @param phone 
   * @param customerName 
   * @returns CustomerProfile Success
   * @throws ApiError
   */
  public static getCustomerGetCustomerProfile(
regno?: string,
email?: string,
phone?: string,
customerName?: string,
): CancelablePromise<CustomerProfile> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Customer/get-customer-profile',
      query: {
        'regno': regno,
        'email': email,
        'phone': phone,
        'customerName': customerName,
      },
    });
  }

  /**
   * @param email 
   * @returns CustomerNotesDto Success
   * @throws ApiError
   */
  public static getCustomerGetCustomerNotes(
email?: string,
): CancelablePromise<Array<CustomerNotesDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Customer/get-customer-notes',
      query: {
        'email': email,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postCustomerAddCustomerNote(
requestBody?: CustomerNoteCreate,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customer/add-customer-note',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
